import { render } from "./UserEditTableTabs.vue?vue&type=template&id=33899062&scoped=true&ts=true"
import script from "./UserEditTableTabs.vue?vue&type=script&lang=ts"
export * from "./UserEditTableTabs.vue?vue&type=script&lang=ts"

import "./UserEditTableTabs.vue?vue&type=style&index=0&id=33899062&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33899062"]])

export default __exports__